import { useContext } from 'react';
import { InferGetServerSidePropsType } from 'next';

import config from 'config';
import withPageLayout from 'core/hocs/withPageLayout';
import { itShops } from 'consts/shopPages';
import { ConfigContext, getShopKey } from '@providers/ConfigProvider';
import { GetPageLayoutResult, serverRequests as pageLayoutServerRequests } from '@layouts/PageLayout/PageLayout.utils';
import { AboutUsCommon, AboutUsDellowo, AboutUsPremiumStation } from '@pages/AboutUs';
import { RequestConfig } from 'utils/combineRequest';
import {
  testimonialRequestConfig,
  GetTestimonialsResult,
  GetTestimonialsVariables,
} from 'graphql/queries/GetTestimonials.query';
import { pageRequestConfig, GetPageResults, GetPageVariables } from 'graphql/queries/GetPageData.query';
import {
  pageFilesRequestConfig,
  GetPagesFilesResults,
  GetPagesFilesVariables,
} from 'graphql/queries/GetPagesFiles.query';
import { numbersRequestConfig, GetNumbersResults, GetNumbersVariables } from 'graphql/queries/GetNumbers.query';
import { GetBrandsResults, brandsRequestConfig } from 'graphql/queries/GetBrands.query';
import getCommonServerSideProps from 'utils/getCommonServerSideProps';

const { routes } = config;

const serverRequests: RequestConfig[] = [
  ...pageLayoutServerRequests,
  pageRequestConfig,
  pageFilesRequestConfig,
  numbersRequestConfig,
  brandsRequestConfig,
];

export const getServerSideProps = getCommonServerSideProps<
  GetPageLayoutResult &
    Partial<GetTestimonialsResult> &
    GetPageResults &
    GetPagesFilesResults &
    GetNumbersResults &
    GetBrandsResults,
  GetTestimonialsVariables & GetPageVariables & GetPagesFilesVariables & GetNumbersVariables
>(
  routes.aboutUs.href,
  ({ shopId }) => [
    ...serverRequests,
    ...(['biznesowe', 'cocon'].includes(getShopKey(shopId)) ? [testimonialRequestConfig] : []),
  ],
  {
    pages: [routes.aboutUs.href, '/partners'],
    numbers: [
      'COCON_START_YEAR',
      'DELLOWO_START_YEAR',
      'CLIENTS',
      'DEVICES_PER_YEAR',
      'BIZNESOWE_START_YEAR',
      'PREMIUM_START_YEAR',
      'DELLOWO_ORDERS',
      'DELLOWO_CLIENTS',
      'DELIVERIES_LESS_24H',
      'WORKSTATIONS_DELIVERED',
      'WORKSTATIONS_DELIVERIES_CLIENTS',
    ],
  },
  (v) => v,
  itShops
);

const AboutUs = ({
  testimonials,
  numbers,
  brands,
}: InferGetServerSidePropsType<typeof getServerSideProps>): JSX.Element => {
  const { isBiznesowe, isDellowo, isPremiumStation, isCocon, isFirewall, isPremiumSerwer } = useContext(ConfigContext);

  return (
    <>
      {(isBiznesowe || isCocon || isFirewall || isPremiumSerwer) && (
        <AboutUsCommon numbers={numbers} testimonials={testimonials} brands={brands} />
      )}
      {isDellowo && <AboutUsDellowo numbers={numbers} brands={brands} />}
      {isPremiumStation && <AboutUsPremiumStation numbers={numbers} brands={brands} />}
    </>
  );
};

export default withPageLayout(AboutUs, {
  breadcrumbVariant: 'aboutUs',
  showBreadcrumb: true,
  withoutBreadcrumbBorder: true,
});
